import * as THREE from "three";
import { LoadGLTFbyPath, LoadGLTFGamebyPath, LoadGLTFImagePanelbyPath, LoadGLTFProgressPanelbyPath, LoadGLTFSkybyPath, LODLoadGLTFbyPath } from "./helpers/modelHelper";

import cameraOrientationState from './helpers/cameraOrientationState';
import {PerspectiveCameraForResizableWindow, handleCameraRotation, handleMouseMovement} from './helpers/cameraWithMouseRotation';

import { EffectComposer } from "three/examples/jsm/Addons.js";
import { RenderPass } from "three/examples/jsm/Addons.js";
import { addOutlineBasedOnIntersections, addOutlineTo2D, addOutlineToAbout, addOutlineToGames, addOutlineToInProg, addOutlineToModels, configureOutlineEffectSettings_Default, getOutlineEffect } from "./helpers/outlineHelper";
import { FXAAShader, ShaderPass } from "three/examples/jsm/Addons.js";
import { GammaCorrectionShader } from "three/examples/jsm/Addons.js";
import { checkRayIntersections, getMouseVector2 } from "./helpers/raycasterHelper";
import { createButtons, createLinkButtons } from "./helpers/buttons";
import { createInfoCard } from "./helpers/infoCards";
import { animateAbout, animateCamera, animateGames, animateImages, animateInProg, animateModel, closeIntroduction, getAt2DFrame, getAt3DShelf, getAtAboutBoard, getAtGameShelf, getAtInProg } from "./helpers/animateCamera";
import { int } from "three/webgpu";

//Scene---------------------------
const scene = new THREE.Scene();

//Renderer------------------------
const renderer = new THREE.WebGLRenderer();
renderer.setSize( window.innerWidth, window.innerHeight );
renderer.setAnimationLoop( animate );
document.body.appendChild( renderer.domElement );


//Lighting-------------------------------
const hemiLight = new THREE.HemisphereLight();
hemiLight.castShadow = true;
hemiLight.receiveShadow = true;
scene.add(hemiLight);

//Camera---------------------------------
const camera = PerspectiveCameraForResizableWindow(
    60,
    0.1, 
    10000, 
    renderer
);

camera.position.set(0, 5, 6);
let cameraMoving = false;
let mouse = new THREE.Vector2();

const cameraOS = new cameraOrientationState();

//Raycaster-----------------------------
const raycaster = new THREE.Raycaster();

document.addEventListener('mousemove', onMouseMove, false);

handleCameraRotation(camera, cameraOS, cameraMoving);

//Loading Manager-----------------
const loadingManager = new THREE.LoadingManager();

const progressBar = document.getElementById('progress-bar');

loadingManager.onProgress = function(url, loaded, total) {
    progressBar.value = (loaded/total) * 100;
}

const progressBarContainer = document.querySelector('.progress-bar-container');

loadingManager.onLoad = function() {
    progressBarContainer.style.display = 'none';
}




//Models--------------------------
const roomPath = './models/room/room_R2.glb';
const skyPath = './models/room/skySphere.glb';

LoadGLTFbyPath(scene, loadingManager, roomPath, 0, 0, 0);
const sky = [];
LoadGLTFSkybyPath(scene, loadingManager, skyPath, sky);

//LODs----------------------------
const scissors_0Path = './models/LODs/Scissors_0.glb';
const scissors_1Path = './models/LODs/Scissors_1.glb';
const scissors_2Path = './models/LODs/Scissors_2.glb';

const snail_0Path = './models/LODs/Snail_0.glb';
const snail_1Path = './models/LODs/Snail_1.glb';
const snail_2Path = './models/LODs/Snail_2.glb';

const ember_0Path = './models/LODs/Ember_0.glb';
const ember_1Path = './models/LODs/Ember_1.glb';
const ember_2Path = './models/LODs/Ember_2.glb';

const alien_0Path = './models/LODs/Alien_0.glb';
const alien_1Path = './models/LODs/Alien_1.glb';
const alien_2Path = './models/LODs/Alien_2.glb';

const beholder_0Path = './models/LODs/Beholder_0.glb';
const beholder_1Path = './models/LODs/Beholder_1.glb';
const beholder_2Path = './models/LODs/Beholder_2.glb';

const golem_0Path = './models/LODs/Golem_0.glb';
const golem_1Path = './models/LODs/Golem_1.glb';
const golem_2Path = './models/LODs/Golem_2.glb';

const skelly_0Path = './models/LODs/Skelly_0.glb';
const skelly_1Path = './models/LODs/Skelly_1.glb';
const skelly_2Path = './models/LODs/Skelly_2.glb';

const charger_0Path = './models/LODs/Charger_0.glb';
const charger_1Path = './models/LODs/Charger_1.glb';
const charger_2Path = './models/LODs/Charger_2.glb';

const lod0Models = [];
const lod1Models = [];
const lod2Models = [];

LODLoadGLTFbyPath(scene, loadingManager, scissors_0Path, -7.4, 2.2, -1.3, 0.025, 0.025, 0.025, false, lod0Models, 0, "Scissors_0 Model");
LODLoadGLTFbyPath(scene, loadingManager, scissors_1Path, -7.35, 2.2, -1.25, 0.025, 0.025, 0.025, false, lod1Models, 0, "Scissors_1 Model");
LODLoadGLTFbyPath(scene, loadingManager, scissors_2Path, -7.4, 2.2, -1.3, 0.025, 0.025, 0.025, true, lod2Models, 0, "Scissors_2 Model");

LODLoadGLTFbyPath(scene, loadingManager, skelly_0Path, -6.7, 2.2, -2.4, 0.35, 0.35, 0.35, false, lod0Models, 1, "Skelly_0 Model");
LODLoadGLTFbyPath(scene, loadingManager, skelly_1Path, -6.65, 2.2, -2.35, 0.35, 0.35, 0.35, false, lod1Models, 1, "Skelly_1 Model");
LODLoadGLTFbyPath(scene, loadingManager, skelly_2Path, -6.7, 2.2, -2.4, 0.35, 0.35, 0.35, true, lod2Models, 1, "Skelly_2 Model");

LODLoadGLTFbyPath(scene, loadingManager, ember_0Path, -7.7, 1.155, -1.3, 0.025, 0.025, 0.025, false, lod0Models, 2, "Ember_0 Model");
LODLoadGLTFbyPath(scene, loadingManager, ember_1Path, -7.65, 1.155, -1.25, 0.025, 0.025, 0.025, false, lod1Models, 2, "Ember_1 Model");
LODLoadGLTFbyPath(scene, loadingManager, ember_2Path, -7.7, 1.155, -1.3, 0.025, 0.025, 0.025, true, lod2Models, 2, "Ember_2 Model");

LODLoadGLTFbyPath(scene, loadingManager, alien_0Path, -6.7, 1.155, -2.4, 0.01, 0.01, 0.01, false, lod0Models, 3, "Alien_0 Model");
LODLoadGLTFbyPath(scene, loadingManager, alien_1Path, -6.65, 1.155, -2.35, 0.01, 0.01, 0.01, false, lod1Models, 3, "Alien_1 Model");
LODLoadGLTFbyPath(scene, loadingManager, alien_2Path, -6.7, 1.155, -2.4, 0.01, 0.01, 0.01, true, lod2Models, 3, "Alien_2 Model");

LODLoadGLTFbyPath(scene, loadingManager, beholder_0Path, -7.7, 0.25, -1.3, 0.007, 0.007, 0.007, false, lod0Models, 4, "Beholder_0 Model");
LODLoadGLTFbyPath(scene, loadingManager, beholder_1Path, -7.65, 0.25, -1.25, 0.007, 0.007, 0.007, false, lod1Models, 4, "Beholder_1 Model");
LODLoadGLTFbyPath(scene, loadingManager, beholder_2Path, -7.7, 0.25, -1.3, 0.007, 0.007, 0.007, true, lod2Models, 4, "Beholder_2 Model");

LODLoadGLTFbyPath(scene, loadingManager, charger_0Path, -6.7, 0.19, -2.4, 0.38, 0.38, 0.38, false, lod0Models, 5, "Charger_0 Model");
LODLoadGLTFbyPath(scene, loadingManager, charger_1Path, -6.65, 0.19, -2.35, 0.38, 0.38, 0.38, false, lod1Models, 5, "Charger_1 Model");
LODLoadGLTFbyPath(scene, loadingManager, charger_2Path, -6.7, 0.19, -2.4, 0.38, 0.38, 0.38, true, lod2Models, 5, "Charger_2 Model");

//2D------------------------------------------------------
const backgroundPath = './models/images/imageBackground.glb';

const dreamEaterPath = './models/images/imageDreamEater.glb';
const dreamEaterZoomPath = './models/images/imageDreamEaterZoom.glb';

const gloryPath = './models/images/imageGlory.glb';
const gloryZoomPath = './models/images/imageGloryZoom.glb';

const skellyPath = './models/images/imageSkelly.glb';
const skellyZoomPath = './models/images/imageSkellyZoom.glb';

const ravenPath = './models/images/imageRaven.glb';
const ravenZoomPath = './models/images/imageRavenZoom.glb';

const wisteriaPath = './models/images/imageWisteria.glb';
const wisteriaZoomPath = './models/images/imageWisteriaZoom.glb';

const shunnedHousePath = './models/images/imageShunnedHouse.glb';
const shunnedHouseZoomPath = './models/images/imageShunnedHouseZoom.glb';

const imagePanels = [];
const imageZoomPanels = [];

LoadGLTFImagePanelbyPath(scene, loadingManager, backgroundPath, false, imagePanels, 0);

LoadGLTFImagePanelbyPath(scene, loadingManager, dreamEaterPath, false, imagePanels, 1);
LoadGLTFImagePanelbyPath(scene, loadingManager, dreamEaterZoomPath, false, imageZoomPanels, 1);

LoadGLTFImagePanelbyPath(scene, loadingManager, gloryPath, false, imagePanels, 2);
LoadGLTFImagePanelbyPath(scene, loadingManager, gloryZoomPath, false, imageZoomPanels, 2);

LoadGLTFImagePanelbyPath(scene, loadingManager, skellyPath, false, imagePanels, 3);
LoadGLTFImagePanelbyPath(scene, loadingManager, skellyZoomPath, false, imageZoomPanels, 3);

LoadGLTFImagePanelbyPath(scene, loadingManager, ravenPath, false, imagePanels, 4);
LoadGLTFImagePanelbyPath(scene, loadingManager, ravenZoomPath, false, imageZoomPanels, 4);

LoadGLTFImagePanelbyPath(scene, loadingManager, wisteriaPath, false, imagePanels, 5);
LoadGLTFImagePanelbyPath(scene, loadingManager, wisteriaZoomPath, false, imageZoomPanels, 5);

LoadGLTFImagePanelbyPath(scene, loadingManager, shunnedHousePath, false, imagePanels, 6);
LoadGLTFImagePanelbyPath(scene, loadingManager, shunnedHouseZoomPath, false, imageZoomPanels, 6);

//About-----------------------------------------
const profilePath = './models/about/aboutProfile.glb';
const whatIDoPath = './models/about/aboutWhatIDo.glb';
const diplomaPath = './models/about/aboutDiploma.glb';
const linkPath = './models/about/aboutLink.glb';
const programsPath = './models/about/aboutPrograms.glb';
const cakeG1MonserBookPath = './models/about/aboutCakeG1MonsterBook.glb';
const cakeG1MouthsPath = './models/about/aboutCakeG1Mouths.glb';
const cakeG1SlenderPath = './models/about/aboutCakeG1Slender.glb';
const cakeG2BunnyPath = './models/about/aboutCakeG2Bunny.glb';
const cakeG2FoxPath = './models/about/aboutCakeG2Fox.glb';
const cakeG2PhoenixPath = './models/about/aboutCakeG2Phoenix.glb';
const cakeG3FlowerPath = './models/about/aboutCakeG3Flower.glb';
const cakeG3NomiCakePath = './models/about/aboutCakeG3NomiCake.glb';
const cakeG3PhilPath = './models/about/aboutCakeG3Phil.glb';
const resumePath = './models/about/aboutResume.glb';

const aboutPanels = [];

LoadGLTFImagePanelbyPath(scene, loadingManager, profilePath, false, aboutPanels, 0);
LoadGLTFImagePanelbyPath(scene, loadingManager, whatIDoPath, false, aboutPanels, 1);
LoadGLTFImagePanelbyPath(scene, loadingManager, diplomaPath, false, aboutPanels, 2);
LoadGLTFImagePanelbyPath(scene, loadingManager, linkPath, false, aboutPanels, 3);
LoadGLTFImagePanelbyPath(scene, loadingManager, programsPath, false, aboutPanels, 4);
LoadGLTFImagePanelbyPath(scene, loadingManager, cakeG1MonserBookPath, false, aboutPanels, 5);
LoadGLTFImagePanelbyPath(scene, loadingManager, cakeG1MouthsPath, false, aboutPanels, 6);
LoadGLTFImagePanelbyPath(scene, loadingManager, cakeG1SlenderPath, false, aboutPanels, 7);
LoadGLTFImagePanelbyPath(scene, loadingManager, cakeG2BunnyPath, false, aboutPanels, 8);
LoadGLTFImagePanelbyPath(scene, loadingManager, cakeG2FoxPath, false, aboutPanels, 9);
LoadGLTFImagePanelbyPath(scene, loadingManager, cakeG2PhoenixPath, false, aboutPanels, 10);
LoadGLTFImagePanelbyPath(scene, loadingManager, cakeG3FlowerPath, false, aboutPanels, 11);
LoadGLTFImagePanelbyPath(scene, loadingManager, cakeG3NomiCakePath, false, aboutPanels, 12);
LoadGLTFImagePanelbyPath(scene, loadingManager, cakeG3PhilPath, false, aboutPanels, 13);
LoadGLTFImagePanelbyPath(scene, loadingManager, resumePath, false, aboutPanels, 14);


const artstationButtonPath = './models/about/buttons/aboutLinkBArtstation.glb';
const youtubeButtonPath = './models/about/buttons/aboutLinkBYoutube.glb';
const itchButtonPath = './models/about/buttons/aboutLinkBItch.glb';
const instagramButtonPath = './models/about/buttons/aboutLinkBInstagram.glb';
const dArtButtonPath = './models/about/buttons/aboutLinkBDArt.glb';
const linkedInButtonPath = './models/about/buttons/aboutLinkBLinkedIn.glb';
const emailButtonPath = './models/about/buttons/aboutLinkBEmail.glb';

const aboutButtons = [];

LoadGLTFImagePanelbyPath(scene, loadingManager, artstationButtonPath, false, aboutButtons, 0);
LoadGLTFImagePanelbyPath(scene, loadingManager, youtubeButtonPath, false, aboutButtons, 1);
LoadGLTFImagePanelbyPath(scene, loadingManager, itchButtonPath, false, aboutButtons, 2);
LoadGLTFImagePanelbyPath(scene, loadingManager, instagramButtonPath, false, aboutButtons, 3);
LoadGLTFImagePanelbyPath(scene, loadingManager, dArtButtonPath, false, aboutButtons, 4);
LoadGLTFImagePanelbyPath(scene, loadingManager, linkedInButtonPath, false, aboutButtons, 5);
LoadGLTFImagePanelbyPath(scene, loadingManager, emailButtonPath, false, aboutButtons, 6);


//Games---------------------------------------------------

const alonePath = './models/games/gameAlone.glb';
const cauldronPath = './models/games/gameCauldron.glb';
const partyPath = './models/games/gameParty.glb';
const snailPath = './models/games/gameSnail.glb';
const icarusPath = './models/games/gameIcarus.glb';

const games = [];

LoadGLTFGamebyPath(scene, loadingManager, alonePath, -0.15, 2.08, -8.5, games, 0);
LoadGLTFGamebyPath(scene, loadingManager, cauldronPath, 0.7, 2.08, -7.8, games, 1);
LoadGLTFGamebyPath(scene, loadingManager, partyPath, 1.5, 2.08, -7.2, games, 2);
LoadGLTFGamebyPath(scene, loadingManager, snailPath, -0.15, 1.05, -8.5, games, 3);
LoadGLTFGamebyPath(scene, loadingManager, icarusPath, 1.5, 1.05, -7.2, games, 4);

//InProgress----------------------------------------------

const desktop1Path = './models/inProg/inProgDesktop1.glb';
const desktop1WorkPath = './models/inProg/inProgDesktop1Work.glb';
const desktop2Path = './models/inProg/inProgDesktop2.glb';
const desktop2WorkPath = './models/inProg/inProgDesktop2Work_U2_2025.glb';
const desktop3Path = './models/inProg/inProgDesktop3.glb';
const desktop3WorkPath = './models/inProg/inProgDesktop3Work_U2_2025.glb';

const inProgPanels = [];

LoadGLTFProgressPanelbyPath(scene, loadingManager, desktop1Path, 0, 0, 0, true, inProgPanels, 0);
LoadGLTFProgressPanelbyPath(scene, loadingManager, desktop1WorkPath, 7.11, 3.81, -2.8, false, inProgPanels, 1);
LoadGLTFProgressPanelbyPath(scene, loadingManager, desktop2Path, 0, 0, 0, true, inProgPanels, 2);
LoadGLTFProgressPanelbyPath(scene, loadingManager, desktop2WorkPath, 7.11, 3.79, 0.67, false, inProgPanels, 3);
LoadGLTFProgressPanelbyPath(scene, loadingManager, desktop3Path, 0, 0, 0, true, inProgPanels, 4);
LoadGLTFProgressPanelbyPath(scene, loadingManager, desktop3WorkPath, 8.15, 3.5, -1.2, false, inProgPanels, 5);


//Buttons------------------------------------------------
const map = new THREE.TextureLoader().load("./images/arrow-button.png");
const material = new THREE.SpriteMaterial({map: map, coloe: 0xffffff});

const buttons = new THREE.Group();
buttons.add(createButtons(material, -5.25, 0.3, -3.25, 0, 0, 0, 'Back 3DShelf'));
buttons.add(createButtons(material, -9.3, 4.7, -0.8, 0, 0, 0, 'Back 2DFrame'));
buttons.add(createButtons(material, -4, 5.25, -6.75, 0, 0, 0, 'Back CorkBoard'));
buttons.add(createButtons(material, -1, 0.5, -7.5, 0, 0, 0, 'Back GameShelf'));
buttons.add(createButtons(material, 8, 2, -1, 0, 0, 0, 'Back Desk'));
buttons.add(createButtons(material, 10, 3.5, -6, 0, 0, 0, 'Back Window'));

const introButton = createButtons(material, 0, 3.25, 3, 0, 0, 0, 'Back Intro');
scene.add(introButton);

scene.add(buttons);

//InfoCards-----------------------------------------------
//3D--------------------------(0-5)
const infoScissorsMap = new THREE.TextureLoader().load("./images/infoCard3DScissors.png");
const infoScissorsMaterial = new THREE.SpriteMaterial({map: infoScissorsMap, color: 0xffffff});

const infoSkelly3DMap = new THREE.TextureLoader().load("./images/infoCard3DSkelly.png");
const infoSkelly3DMaterial = new THREE.SpriteMaterial({map: infoSkelly3DMap, color: 0xffffff});

const infoEmberMap = new THREE.TextureLoader().load("./images/infoCard3DEmber.png");
const infoEmberMaterial = new THREE.SpriteMaterial({map: infoEmberMap, color: 0xffffff});

const infoAlienMap = new THREE.TextureLoader().load("./images/infoCard3DAlien.png");
const infoAlienMaterial = new THREE.SpriteMaterial({map: infoAlienMap, color: 0xffffff});

const infoBeholderMap = new THREE.TextureLoader().load("./images/infoCard3DBeholder.png");
const infoBeholderMaterial = new THREE.SpriteMaterial({map: infoBeholderMap, color: 0xffffff});

const infoChargerMap = new THREE.TextureLoader().load("./images/infoCard3DCharger.png");
const infoChargerMaterial = new THREE.SpriteMaterial({map: infoChargerMap, color: 0xffffff});

const infoCards = [];

//if visible set y to 1.65 - models
//if visible set y to 2 - games

createInfoCard(scene, infoScissorsMaterial, -7.25, -2, 0.15, 2.5, "3D Scissors Card", infoCards, 0);
createInfoCard(scene, infoSkelly3DMaterial, -7.25, -2, 0.15, 2.5, "3D Skelly Card", infoCards, 1);
createInfoCard(scene, infoEmberMaterial, -7.25, -2, 0.15, 2.5, "3D Ember Card", infoCards, 2);
createInfoCard(scene, infoAlienMaterial, -7.25, -2, 0.15, 2.5, "3D Alien Card", infoCards, 3);
createInfoCard(scene, infoBeholderMaterial, -7.25, -2, 0.15, 2.5, "3D Beholder Card", infoCards, 4);
createInfoCard(scene, infoChargerMaterial, -7.25, -2, 0.15, 2.5, "3D Charger Card", infoCards, 5);

//2D------------------------(6-11)
const infoIntroMap = new THREE.TextureLoader().load("./images/infoCard2DIntro.png");
const infoIntroMaterial = new THREE.SpriteMaterial({map: infoIntroMap, color: 0xffffff});

const infoDreamEaterMap = new THREE.TextureLoader().load("./images/infoCard2DDreamEater.png");
const infoDreamEaterMaterial = new THREE.SpriteMaterial({map: infoDreamEaterMap, color: 0xffffff});

const infoGloryMap = new THREE.TextureLoader().load("./images/infoCard2DGlory.png");
const infoGloryMaterial = new THREE.SpriteMaterial({map: infoGloryMap, color: 0xffffff});

const infoSkellyMap = new THREE.TextureLoader().load("./images/infoCard2DSkelly.png");
const infoSkellyMaterial = new THREE.SpriteMaterial({map: infoSkellyMap, color: 0xffffff});

const infoRavenMap = new THREE.TextureLoader().load("./images/infoCard2DRaven.png");
const infoRavenMaterial = new THREE.SpriteMaterial({map: infoRavenMap, color: 0xffffff});

const infoWisteriaMap = new THREE.TextureLoader().load("./images/infoCard2DWisteria.png");
const infoWisteriaMaterial = new THREE.SpriteMaterial({map: infoWisteriaMap, color: 0xffffff});

const infoShunnedHouseMap = new THREE.TextureLoader().load("./images/infoCard2DShunnedHouse.png");
const infoShunnedHouseMaterial = new THREE.SpriteMaterial({map: infoShunnedHouseMap, color: 0xffffff});

createInfoCard(scene, infoIntroMaterial, -9.3, 5.58, -0.8, 1.5, "2D Intro Card", infoCards, 6);
createInfoCard(scene, infoDreamEaterMaterial, -9.3, 5.58, -0.8, 1.5, "2D DreamEater Card", infoCards, 7);
createInfoCard(scene, infoGloryMaterial, -9.3, 5.58, -0.8, 1.5, "2D Glory Card", infoCards, 8);
createInfoCard(scene, infoSkellyMaterial, -9.3, 5.58, -0.8, 1.5, "2D Skelly Card", infoCards, 9);
createInfoCard(scene, infoRavenMaterial, -9.3, 5.58, -0.8, 1.5, "2D Raven Card", infoCards, 10);
createInfoCard(scene, infoWisteriaMaterial, -9.3, 5.58, -0.8, 1.5, "2D Wisteria Card", infoCards, 11);
createInfoCard(scene, infoShunnedHouseMaterial, -9.3, 5.58, -0.8, 1.5, "2D ShunnedHouse Card", infoCards, 12);

//Games ---------------------(13-16)

const infoAloneMap = new THREE.TextureLoader().load("./images/infoCardGameAlone.png");
const infoAloneMaterial = new THREE.SpriteMaterial({map: infoAloneMap, color: 0xffffff});

const infoCauldronMap = new THREE.TextureLoader().load("./images/infoCardGameCauldron.png");
const infoCauldronMaterial = new THREE.SpriteMaterial({map: infoCauldronMap, color: 0xffffff});

const infoPartyMap = new THREE.TextureLoader().load("./images/infoCardGameParty.png");
const infoPartyMaterial = new THREE.SpriteMaterial({map: infoPartyMap, color: 0xffffff});

const infoSnailGameMap = new THREE.TextureLoader().load("./images/infoCardGameSnail.png");
const infoSnailGameMaterial = new THREE.SpriteMaterial({map: infoSnailGameMap, color: 0xffffff});

createInfoCard(scene, infoAloneMaterial, -1, -2, -8, 3, "Games Alone Card", infoCards, 13);
createInfoCard(scene, infoCauldronMaterial, -1, -2, -8, 3, "Games Cauldron Card", infoCards, 14);
createInfoCard(scene, infoPartyMaterial, -1, -2, -8, 3, "Games Party Card", infoCards, 15);
createInfoCard(scene, infoSnailGameMaterial, -1, -2, -8, 3, "Games Snail Card", infoCards, 16);


//IntroCard--------------------------------------------------------------------------------------------

const portfolioIntroMap = new THREE.TextureLoader().load("./images/portfolioIntro.png");
const portfolioIntroMaterial = new THREE.SpriteMaterial({map: portfolioIntroMap, color: 0Xffffff});

createInfoCard(scene, portfolioIntroMaterial, 0, 5, 2.75, 3, "Portfolio Intro", infoCards, 17);

//ShowMore Info Cards------------------------------------------------------

const infoAloneShowMoreMap = new THREE.TextureLoader().load("./images/infoCardAloneSeeMore.png");
const infoAloneShowMoreMaterial = new THREE.SpriteMaterial({map: infoAloneShowMoreMap, color: 0xffffff});

const infoCauldronShowMoreMap = new THREE.TextureLoader().load("./images/infoCardCauldronSeeMore.png");
const infoCauldronShowMoreMaterial = new THREE.SpriteMaterial({map: infoCauldronShowMoreMap, color: 0xffffff});

const infoPartyShowMoreMap = new THREE.TextureLoader().load("./images/infoCardPartySeeMore.png");
const infoPartyShowMoreMaterial = new THREE.SpriteMaterial({map: infoPartyShowMoreMap, color: 0xffffff});

const infoSnailShowMoreMap = new THREE.TextureLoader().load("./images/infoCardSnailSeeMore.png");
const infoSnailShowMoreMaterial = new THREE.SpriteMaterial({map: infoSnailShowMoreMap, color: 0xffffff});

createInfoCard(scene, infoAloneShowMoreMaterial, -1, -2, -8, 3, "Games Alone More", infoCards, 18);
createInfoCard(scene, infoCauldronShowMoreMaterial, -1, -2, -8, 3, "Games Cauldron More", infoCards, 19);
createInfoCard(scene, infoPartyShowMoreMaterial, -1, -2, -8, 3, "Games Party More", infoCards, 20);
createInfoCard(scene, infoSnailShowMoreMaterial, -1, -2, -8, 3, "Games Snail More", infoCards, 21);

//U2_2025 Update To Game InfoCards
//Added Icarus

const infoIcarusMap = new THREE.TextureLoader().load("./images/infoCardGameIcarus.png");
const infoIcarusMaterial = new THREE.SpriteMaterial({map: infoIcarusMap, color: 0xffffff});

const infoIcarusSeeMoreMap = new THREE.TextureLoader().load("./images/infoCardIcarusSeeMore.png");
const infoIcarusSeeMoreMaterial = new THREE.SpriteMaterial({map: infoIcarusSeeMoreMap, color: 0xffffff});

createInfoCard(scene, infoIcarusMaterial, -1, -2, -8, 3, "Games Icarus Card", infoCards, 22);
createInfoCard(scene, infoIcarusSeeMoreMaterial, -1, -2, -8, 3, "Games Icarus More", infoCards, 23);



//Link Buttons ----------------------------------------------------------------------------------------

const linkButtonMap = new THREE.TextureLoader().load("./images/link-button.png");
const linkButtonMaterial = new THREE.SpriteMaterial({map: linkButtonMap, color: 0xffffff});

const linkButtons = [];

//3D Models -----------(0-5)----------------set to 0.86 on y
createLinkButtons(scene, linkButtonMaterial, -7.25, -2, 0.42, 1.45, 0.45, 1, 'Scissors Link Artstation', linkButtons, 0);
createLinkButtons(scene, linkButtonMaterial, -7.25, -2, 0.42, 1.45, 0.45, 1, 'Skelly Link Artstation', linkButtons, 1);
createLinkButtons(scene, linkButtonMaterial, -7.25, -2, 0.42, 1.45, 0.45, 1, 'Ember Link Artstation', linkButtons, 2);
createLinkButtons(scene, linkButtonMaterial, -7.25, -2, 0.42, 1.45, 0.45, 1, 'Alien Link Artstation', linkButtons, 3);
createLinkButtons(scene, linkButtonMaterial, -7.25, -2, 0.42, 1.45, 0.45, 1, 'Beholder Link Artstation', linkButtons, 4);
createLinkButtons(scene, linkButtonMaterial, -7.25, -2, 0.42, 1.45, 0.45, 1, 'Charger Link Artstation', linkButtons, 5);

//2D Images-------------(6-26)-------set to -9.6(Insta), -9.3(Youtube), -9(DArt)
createLinkButtons(scene, linkButtonMaterial, -10.6, 4.98, -0.42, 0.25, 0.25, 0.25, 'Intro Link Instagram', linkButtons, 6);
createLinkButtons(scene, linkButtonMaterial, -10.3, 4.98, -0.77, 0.35, 0.25, 0.25, 'Intro Link Youtube', linkButtons, 7);
createLinkButtons(scene, linkButtonMaterial, -10, 4.98, -1.12, 0.25, 0.25, 0.25, 'Intro Link DArt', linkButtons, 8);

createLinkButtons(scene, linkButtonMaterial, -10.6, 4.98, -0.42, 0.25, 0.25, 0.25, 'DreamEater Link Instagram', linkButtons, 9);
createLinkButtons(scene, linkButtonMaterial, -10.3, 4.98, -0.77, 0.35, 0.25, 0.25, 'DreamEater Link Youtube', linkButtons, 10);
createLinkButtons(scene, linkButtonMaterial, -10, 4.98, -1.12, 0.25, 0.25, 0.25, 'DreamEater Link DArt', linkButtons, 11);

createLinkButtons(scene, linkButtonMaterial, -10.6, 4.98, -0.42, 0.25, 0.25, 0.25, 'Glory Link Instagram', linkButtons, 12);
createLinkButtons(scene, linkButtonMaterial, -10.3, 4.98, -0.77, 0.35, 0.25, 0.25, 'Glory Link Youtube', linkButtons, 13);
createLinkButtons(scene, linkButtonMaterial, -10, 4.98, -1.12, 0.25, 0.25, 0.25, 'Glory Link DArt', linkButtons, 14);

createLinkButtons(scene, linkButtonMaterial, -10.6, 4.98, -0.42, 0.25, 0.25, 0.25, 'Skelly Link Instagram', linkButtons, 15);
createLinkButtons(scene, linkButtonMaterial, -10.3, 4.98, -0.77, 0.35, 0.25, 0.25, 'Skelly Link Youtube', linkButtons, 16);
createLinkButtons(scene, linkButtonMaterial, -10, 4.98, -1.12, 0.25, 0.25, 0.25, 'Skelly Link DArt', linkButtons, 17);

createLinkButtons(scene, linkButtonMaterial, -10.6, 4.98, -0.42, 0.25, 0.25, 0.25, 'Raven Link Instagram', linkButtons, 18);
createLinkButtons(scene, linkButtonMaterial, -10.3, 4.98, -0.77, 0.35, 0.25, 0.25, 'Raven Link Youtube', linkButtons, 19);
createLinkButtons(scene, linkButtonMaterial, -10, 4.98, -1.12, 0.25, 0.25, 0.25, 'Raven Link DArt', linkButtons, 20);

createLinkButtons(scene, linkButtonMaterial, -10.6, 4.98, -0.42, 0.25, 0.25, 0.25, 'Wisteria Link Instagram', linkButtons, 21);
createLinkButtons(scene, linkButtonMaterial, -10.3, 4.98, -0.77, 0.35, 0.25, 0.25, 'Wisteria Link Youtube', linkButtons, 22);
createLinkButtons(scene, linkButtonMaterial, -10, 4.98, -1.12, 0.25, 0.25, 0.25, 'Wisteria Link DArt', linkButtons, 23);

createLinkButtons(scene, linkButtonMaterial, -10.6, 4.98, -0.42, 0.25, 0.25, 0.25, 'ShunnedHouse Link Instagram', linkButtons, 24);
createLinkButtons(scene, linkButtonMaterial, -10.3, 4.98, -0.77, 0.35, 0.25, 0.25, 'ShunnedHouse Link Youtube', linkButtons, 25);
createLinkButtons(scene, linkButtonMaterial, -10, 4.98, -1.12, 0.25, 0.25, 0.25, 'ShunnedHouse Link DArt', linkButtons, 26);

//Games Links and Show More ------------------------------------------------------------------------

const downloadButtonMap = new THREE.TextureLoader().load("./images/download-button.png");
const downloadButtonMaterial = new THREE.SpriteMaterial({map: downloadButtonMap, color: 0xffffff});

const playButtonMap = new THREE.TextureLoader().load("./images/play-button.png");
const playButtonMaterial = new THREE.SpriteMaterial({map: playButtonMap, color: 0xffffff});

const showMoreButtonMap = new THREE.TextureLoader().load("./images/showMore-button.png");
const showMoreButtonMaterial = new THREE.SpriteMaterial({map: showMoreButtonMap, color: 0xffffff});

const showCoverButtonMap = new THREE.TextureLoader().load("./images/showCover-button.png");
const showCoverButtonMaterial = new THREE.SpriteMaterial({map: showCoverButtonMap, color: 0xffffff});

//Set Download to 1.5 on Y
createLinkButtons(scene, downloadButtonMaterial, 0.7, -1.4, -6, 1.60, 0.50, 1.60, "Alone Link Itch", linkButtons, 27);
createLinkButtons(scene, playButtonMaterial, 0.7, -1.4, -6, 1.60, 0.50, 1.60, "Cauldron Link Itch", linkButtons, 28);
createLinkButtons(scene, downloadButtonMaterial, 0.7, -1.4, -6, 1.60, 0.50, 1.60, "Party Link Itch", linkButtons, 29);
createLinkButtons(scene, downloadButtonMaterial, 0.7, -1.4, -6, 1.60, 0.50, 1.60, "Snail Link Itch", linkButtons, 30);


//Model Blocker ----------set 1.6 on y
//Progress Blocker -----------set 4 on y
//Games Blocker ------------set 0.1 on y
createLinkButtons(scene, linkButtonMaterial, -6.3, -1.6, -1, 2.2, 2.2, 2.2, "Blocker3D", linkButtons, 31);
createLinkButtons(scene, linkButtonMaterial, 4.7, -4, -1, 3, 2.2, 2.2, "BlockerP", linkButtons, 32);
createLinkButtons(scene, linkButtonMaterial, 0, 5, 2.25, 10, 10, 10, "BlockerI", linkButtons, 33);
createLinkButtons(scene, linkButtonMaterial, 0.3, -5, -7.5, 5, 5, 5, "BlockerG", linkButtons, 45);

//ShowMore Buttons -------------- set 1.2 on y
createLinkButtons(scene, showMoreButtonMaterial, 0.25, -1.2, -6, 0.75, 0.25, 0.75, "Alone Show More", linkButtons, 34);
createLinkButtons(scene, showMoreButtonMaterial, 0.25, -1.2, -6, 0.75, 0.25, 0.75, "Cauldron Show More", linkButtons, 35);
createLinkButtons(scene, showMoreButtonMaterial, 0.25, -1.2, -6, 0.75, 0.25, 0.75, "Party Show More", linkButtons, 36);
createLinkButtons(scene, showMoreButtonMaterial, 0.25, -1.2, -6, 0.75, 0.25, 0.75, "Snail Show More", linkButtons, 37);

//ShowCover Buttons -------------- set 1.2 on y
createLinkButtons(scene, showCoverButtonMaterial, 0.25, -1.2, -6, 0.75, 0.25, 0.75, "Alone Show Cover", linkButtons, 38);
createLinkButtons(scene, showCoverButtonMaterial, 0.25, -1.2, -6, 0.75, 0.25, 0.75, "Cauldron Show Cover", linkButtons, 39);
createLinkButtons(scene, showCoverButtonMaterial, 0.25, -1.2, -6, 0.75, 0.25, 0.75, "Party Show Cover", linkButtons, 40);
createLinkButtons(scene, showCoverButtonMaterial, 0.25, -1.2, -6, 0.75, 0.25, 0.75, "Snail Show Cover", linkButtons, 41);

//U2_2025 Updates to Game Buttons
//Added Icarus
createLinkButtons(scene, showMoreButtonMaterial, 0.25, -1.2, -6, 0.75, 0.25, 0.75, "Icarus Show More", linkButtons, 42);
createLinkButtons(scene, showCoverButtonMaterial, 0.25, -1.2, -6, 0.75, 0.25, 0.75, "Icarus Show Cover", linkButtons, 43);
createLinkButtons(scene, playButtonMaterial, 0.7, -1.4, -6, 1.60, 0.50, 1.60, "Icarus Link Itch", linkButtons, 44);





//Effect Composer---------------------------------------------------------
let composer = new EffectComposer(renderer);
const renderPass = new RenderPass(scene, camera);
composer.addPass(renderPass);

let outlinePass = getOutlineEffect(window, scene, camera);
configureOutlineEffectSettings_Default(outlinePass);
composer.addPass(outlinePass);

const fxaaShader = new ShaderPass(FXAAShader);
fxaaShader.uniforms["resolution"].value.set(1/window.innerWidth, 1/window.innerHeight);
composer.addPass(fxaaShader);

const gammaCorrectionShader = new ShaderPass(GammaCorrectionShader);
composer.addPass(gammaCorrectionShader);

//Navigation----------------------
let at3DShelf = getAt3DShelf();
let at2DFrame = getAt2DFrame();
let atAboutBoard = getAtAboutBoard();
let atGamesShelf = getAtGameShelf();
let atInProg = getAtInProg();

document.addEventListener('mousemove', onMouseMove, false);

function onMouseMove(event) {

    mouse.x = (event.clientX/window.innerWidth) * 2 - 1;
    mouse.y = (event.clientY/window.innerHeight) * 2 - 1;

    handleMouseMovement(mouse.x, mouse.y, cameraOS);
    mouse = getMouseVector2(event, window);
    const intersections = checkRayIntersections(mouse, camera, raycaster, scene);

    at3DShelf = getAt3DShelf();
    at2DFrame = getAt2DFrame();
    atAboutBoard = getAtAboutBoard();
    atGamesShelf = getAtGameShelf();
    atInProg = getAtInProg();

    if (at3DShelf) {
        addOutlineToModels(intersections, outlinePass);
    }
    else if (at2DFrame) {
        addOutlineTo2D(intersections, outlinePass);
    }
    else if (atAboutBoard) {
        addOutlineToAbout(intersections, outlinePass);
    }
    else if (atGamesShelf) {
        addOutlineToGames(intersections, outlinePass);
    }
    else if (atInProg) {
        addOutlineToInProg(intersections, outlinePass);
    }
    else {
        addOutlineBasedOnIntersections(intersections, outlinePass);
    }

}

document.addEventListener('mousedown', onMouseDown, false);

function onMouseDown(event){
    mouse = getMouseVector2(event, window);
    const intersections = checkRayIntersections(mouse, camera, raycaster, scene);

    animateCamera(
        intersections,
        camera,
        buttons,
        lod0Models,
        lod1Models,
        lod2Models,
        imagePanels,
        imageZoomPanels,
        aboutPanels,
        aboutButtons,
        games,
        inProgPanels,
        infoCards,
        linkButtons,
        cameraOS
    );

    animateModel(intersections, lod0Models, lod1Models, infoCards, linkButtons);

    animateImages(intersections, imagePanels, imageZoomPanels, infoCards, linkButtons);

    animateAbout(intersections, aboutPanels);

    animateGames(intersections, games, infoCards, linkButtons);

    animateInProg(intersections, inProgPanels, linkButtons);

    closeIntroduction(intersections, infoCards, linkButtons, introButton);
}

function portfolioIntro() {
    infoCards[17].visible = true;
    introButton.visible = true;
}

portfolioIntro();

//Animation-----------------------
function animate () {

    requestAnimationFrame(animate);
    let time = Date.now() * 0.00001
    sky[0].rotation.y = time;
    sky[0].rotation.z = 0.0005 * (1 + Math.sin(time));



    handleCameraRotation(camera, cameraOS, cameraMoving);
    composer.render();
}